module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/settings/staff/staff.html
// module id = 484
// module chunks = 0